import { computed, defineComponent, onMounted, reactive, ref, watch } from "vue";
import { Form } from "ant-design-vue";

import { columns, columns2 } from "./maintenance-contract-select-table.constant";
import { useEventbus } from "@/core";
import { ProfilePageReq, ProfileService } from "@/views/contract";

import ProjectTypeSelect from "../project-type-select/index.vue";
import CompanySearchSelect from "../company-search-select/index.vue";
import SalesManSelect from "../sales-man-select/index.vue";
import { UseContractManageService } from "@/views/signatures/contract-management/contract-service";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import { GuaranteeAgreementService } from "@/views/maintenance/guarantee-agreement/guarantee-agreement.service";
export default defineComponent({
  isGlobal: true,
  name: "MaintenanceContractSelectTable",
  components: { ProjectTypeSelect, CompanySearchSelect, SalesManSelect },
  props: {
    contractId: { type: String, default: undefined },
    maintenanceProjectId: { type: String, default: undefined },
    electronicContractId: { type: String, default: undefined },
    contractName: { type: String, default: undefined },
  },
  emits: ["update:electronicContractId", "update:contractId", "update:contractName", "change"],
  setup(props, { emit }) {
    const visible = ref(false);
    const selectedKeys = ref<any>({});
    let isError = ref(false);
    const queryRef = reactive(new ProfilePageReq());
    const {
      data: dataSource,
      loading,
      run,
      refresh,
    } = GuaranteeAgreementService.useGetContractApi();

    const valueName = ref("");
    let contractType = ref("0");
    const search = async () => {
      selectedKeys.value = {};
      queryRef.current = 1;
      queryRef.projectId = props.maintenanceProjectId || "";
      await run(queryRef.projectId);
    };

    const showModal = async () => {
      await search();
      visible.value = true;
    };

    const closeModal = () => {
      visible.value = false;
    };

    const ok = () => {
      if (selectedKeys.value?.contractId) {
        valueName.value = selectedKeys.value.contractName;
        emit(
          "update:electronicContractId",
          selectedKeys.value.type == "dzqht" ? selectedKeys.value?.contractId : null
        );
        emit(
          "update:contractId",
          selectedKeys.value.type == "gcht" ? selectedKeys.value?.contractId : null
        );
        emit("change", selectedKeys.value);
        emit("update:contractName", selectedKeys.value?.contractName);
        isError.value = false;
      }
      closeModal();
    };

    watch(
      () => props.maintenanceProjectId, //选择项目改变时
      async (n, o) => {
        // console.log("🚀 ~ file: maintenance-contract-select-table.controller.ts:76 ~ n:", n);
        if (n && o && n != o) {
          await search();
          emit("update:electronicContractId", null);
          emit("update:contractId", null);
          emit("update:contractName", null);
          valueName.value = "";
        } else {
          emit("update:electronicContractId", props.electronicContractId);
          emit("update:contractId", props.contractId);
          emit("update:contractName", props.contractName);
          valueName.value = props.contractName || "";
        }

        // selectedKeys.value = props.value ? [props.value] : [];
      },
      { immediate: true }
    );

    watch(
      () => [props.electronicContractId, props.contractId], //选择项目改变时
      async (n) => {
        if (!n[0] && !n[1]) {
          return;
        }
        if (!dataSource.value?.records && props.maintenanceProjectId) {
          await search();
          let item = (dataSource.value.records || []).find(
            (d) => d.contractId == n[0] || d.contractId == n[1]
          );
          if (item) {
            selectedKeys.value = item;
            valueName.value = item.contractName;
          }
        } else {
          let item = (dataSource.value?.records || []).find(
            (d) => d.contractId == n[0] || d.contractId == n[1]
          );
          if (item) {
            selectedKeys.value = item;
            valueName.value = item.contractName;
          }
        }
        // // console.log(
        //   "🚀 ~ file: maintenance-contract-select-table.controller.ts:112 ~ valueName.value:",
        //   valueName.value
        // );
        // selectedKeys.value = props.value ? [props.value] : [];
      },
      { immediate: true }
    );
    const reset = async () => {
      await search();
    };

    const onTableChange = async (pagination) => {
      queryRef.current = pagination.current;
      queryRef.size = pagination.pageSize;
      await run(queryRef);
    };

    const onRadioChange = ({ item }) => {
      // console.log("🚀 ~ file: project-select-table.controller.ts:83 ~ onRadioChange ~ item:", item);

      selectedKeys.value = item[0];
    };
    const inputChange = (e) => {
      // console.log("🚀 ~ file: project-select-table.controller.ts:87 ~ inputChange ~ e:", e);
    };

    onMountedOrActivated(async () => {});

    const contractTypeChange = () => {};

    return {
      visible,
      showModal,
      closeModal,
      ok,
      selectedKeys,
      valueName,
      queryRef,
      loading,
      dataSource,
      columns,
      refresh,
      reset,
      search,
      onTableChange,
      onRadioChange,
      // removeSelected,
      isError,
      inputChange,
      contractType,
      contractTypeChange,
      columns2,
    };
  },
});
